/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_Show_LabelInputs */



/**
* | output |
* | --- |
* | "Show key" |
*
* @param {Options_Api_Keys_Show_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_show_label = /** @type {((inputs?: Options_Api_Keys_Show_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_Show_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Afficher la clé")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schlüssel anzeigen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mostra chiave")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Показать ключ")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mostrar clave")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("显示密钥")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キーを表示")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कुंजी दिखाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mostrar chave")
	return /** @type {LocalizedString} */ ("Show key")
});